import uuidv4 from 'uuid/v4';

export default class Channel {
  uid = uuidv4();
  name = '';
  description = '';
  latitude = null;
  longitude = null;
  created_at = null;
  elevation = null;
  constructor(initializer = {}) {
    Object.assign(this, initializer);
  }
}



// WEBPACK FOOTER //
// ./src/models/channel/Channel.js